let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9sH4y")).then(() => parcelRequire('gsNlF'));